<template>
  <div class="h-full flex flex-col min-h-0 bg-[#fafbfc] relative overflow-hidden min-w-0">
    <header class="px-8 py-6 sticky top-0 z-20 bg-[#fafbfc]/90 backdrop-blur-md border-b border-[#1c4848]/5 shrink-0">
      <div class="max-w-[1600px] mx-auto flex items-center justify-between">
        <div>
          <div class="flex items-center gap-2 text-[#1c4848]/40 mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="shrink-0"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/><path d="M8 7h8"/><path d="M8 11h8"/></svg>
            <span class="text-[10px] font-bold uppercase tracking-wider">Library / Books</span>
          </div>
          <h1 class="text-2xl font-serif font-medium text-[#1c4848] tracking-tight">
            Book Collection
          </h1>
        </div>

        <div class="flex items-center gap-4">
          <div class="relative hidden md:block">
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search by title, ISBN..."
              class="pl-10 pr-4 py-2.5 bg-white border border-[#1c4848]/10 rounded-xl text-sm font-medium text-[#1c4848] focus:border-[#1c4848]/30 outline-none w-64 shadow-sm"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#1c4848]/40"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          </div>
          <button
            type="button"
            class="flex items-center gap-2 px-5 py-2.5 bg-[#1c4848] text-white rounded-xl shadow-lg shadow-[#1c4848]/20 hover:bg-[#153838] active:scale-95 transition-all"
            @click="openAddBook"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
            <span class="text-xs font-bold tracking-wide">Add New Book</span>
          </button>
        </div>
      </div>
    </header>

    <Suspense>
      <LibraryContent v-model:search-query="searchQuery" @edit="openEditModal" />
      <template #fallback>
        <div class="flex-1 min-h-0 overflow-y-auto custom-scrollbar pt-8 pr-8 pb-32 pl-8">
          <div class="max-w-[1600px] mx-auto space-y-6">
            <div class="flex gap-2 overflow-x-auto custom-scrollbar pb-2">
              <div class="h-9 w-24 rounded-full bg-[#1c4848]/10 animate-pulse" />
              <div class="h-9 w-28 rounded-full bg-[#1c4848]/5 animate-pulse" />
              <div class="h-9 w-32 rounded-full bg-[#1c4848]/5 animate-pulse" />
            </div>
            <div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
              <BookCardSkeleton v-for="i in 4" :key="i" />
            </div>
          </div>
        </div>
      </template>
    </Suspense>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useModal } from 'vue-final-modal';
import LibraryContent from '@/pages/LibraryContent.vue';
import BookCardSkeleton from '@/components/BookCardSkeleton.vue';
import EditBookModal from '@/components/app/dashboard/modals/EditBookModal.vue';

const searchQuery = ref('');

function openEditModal(book) {
  const { open, close } = useModal({
    component: EditBookModal,
    attrs: {
      book: book ?? null,
      onClose: () => close(),
      onConfirm: () => close(),
    },
  });
  open();
}

function openAddBook() {
  openEditModal(null);
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: rgba(28, 72, 72, 0.1); border-radius: 20px; }
.custom-scrollbar:hover::-webkit-scrollbar-thumb { background-color: rgba(28, 72, 72, 0.2); }
</style>
